export default {"src":"/_next/static/media/SETUP_GUIDE_EMPTY_CHECKBOX.3afff709.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};